import { useMemo } from 'react';
import Highcharts from 'highcharts';
import { makeObjectOutOfArrays } from '../utils';

export const userTranFormNetPromotorScore = data => {
  // let { columns: npsColumns, metric_data: npsMetricData } = data?.serverData;
  let { columns: npsColumns, metric_data: npsMetricData } = data?.cstData || {};
  let npsDataObj = makeObjectOutOfArrays(npsColumns, npsMetricData?.[0]);

  const value = npsDataObj?.promoter_percentage - npsDataObj?.detractor_percentage;
  const subLabelValue = (value - npsDataObj?.benchmark_average_nps)?.toFixed(2)
  const subLabel = `${subLabelValue > 0 ? '+' : '-'}  ${subLabelValue}`;

  return useMemo(() => {
    const defaultOptions = data?.data;

    const extraConfig = {
      centerLabel: {
        label: value,
        subLabel: subLabel
      },
      indicatorSegments: [{ ...defaultOptions?.indicatorSegments[0], value: value || 0 }]
    };

    const options = Highcharts.merge(defaultOptions, extraConfig);

    return { npsDataObj, options };
  }, []);
};
